import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Link, useLocation } from "react-router-dom";
import MoreData from "./More";
import axios from "axios";

const Detail = (prop) => {
	const [state, setState] = useState([]);
	const [linkset, setLink] = useState();
	const [clicked, setClicked] = useState(false);
	const [isDragged, setIsDragged] = useState(false);
	const [num, setNum] = useState(1);
	const [showPresent, setShowPresent] = useState(false);
	const [sameMovie, setSameMovie] = useState([]);
	const [sameTvShow, setSameTvShow] = useState([]);
	const [tvCast, setTvCast] = useState([]);
	let link = "";

	const location = useLocation();
	const data = location.state !== null && { ...location.state.data };
	let id = data[0].id;
	console.log("/////////////////////", data[0]);
	console.log("\\\\\\\\\\\\\\\\\\\\\\", data[0].id);

	const playTrailer = () => {
		// document.getElementById("player").style.display = "block";
		// document.getElementById("closed").style.display = "block";
		setNum(() => {
			return 1;
		});
		setClicked(true);
		// window.addEventListener("click", setClicked(false));
		// document.getElementById("detail").style.opacity = 0.5;
		// setBackDrop(true);
	};
	// if (backdrop === true) {
	// 	window.addEventListener("click", () => {
	// 		document.getElementById("player").style.display = "none";
	// 	});
	// 	setBackDrop(false);
	// }

	useEffect(() => {
		if (data[0].original_name) {
			fetch(
				`https://api.themoviedb.org/3/tv/${id}/credits?api_key=0bcafd5b459497ec53d81e9fc940f86d&language=en-US`
			)
				.then((res) => res.json())
				.then((res) => {
					// setSameMovie(res.data.results);
					setTvCast(res.cast);
					console.log("TvCast", res);
				})
				.catch((error) => console.log("error no cast found", error));
		} else {
			fetch(
				`https://api.themoviedb.org/3/movie/${id}/credits?api_key=0bcafd5b459497ec53d81e9fc940f86d&language=en-US`
			)
				.then((res) => res.json())
				.then((e) => {
					setState(e.cast);
					console.log("person id find", e);
				})
				.catch((error) => {
					console.log(error);
				});
		}

		fetch(
			`https://api.themoviedb.org/3/movie/${id}/videos?api_key=0bcafd5b459497ec53d81e9fc940f86d&language=en-US`
		)
			.then((res) => res.json())
			.then((res) => {
				const Trailer = res.results.filter((e) => {
					return e.type === "Trailer";
				});
				const Teaser = res.results.filter((e) => {
					return e.type === "Teaser";
				});
				console.log("Teaser or Trailer", res);
				console.log("Trailer", Trailer);
				console.log("Teaser", Teaser);
				if (res.results.length >= 1) {
					setLink((prev) => {
						return Trailer[0].key !== undefined
							? Trailer[0].key
							: Teaser[0].key;
					});
				}
			})
			.catch((error) => console.log(error));
		fetch(
			`https://api.themoviedb.org/3/tv/${id}/recommendations?api_key=0bcafd5b459497ec53d81e9fc940f86d&language=en-US&page=1`
		)
			.then((res) => res.json())
			.then((e) => {
				setSameTvShow(e.results);
				console.log("sameTv using fetch", e.results);
			});
		// fetch(
		// 	`https://api.themoviedb.org/3/tv/1412/recommendations?api_key=0bcafd5b459497ec53d81e9fc940f86d&language=en-US&page=1`
		// )
		// 	.then((res) => res.json())
		// 	.then((e) => {
		// 		// setSameTvShow(e.results);
		// 		console.log("sameTv using fetch 1412", e.results);
		// 	});

		fetch(
			`https://api.themoviedb.org/3/movie/${id}/recommendations?api_key=0bcafd5b459497ec53d81e9fc940f86d&language=en-US&page=1`
		)
			.then((res) => res.json())
			.then((e) => {
				setSameMovie(e.results);
				console.log("sameMovie using fetch ", e.results);
			});
		// axios
		// 	.get(
		// 		`https://api.themoviedb.org/3/tv/${id}/recommendations?api_key=0bcafd5b459497ec53d81e9fc940f86d&language=en-US&page=1`
		// 	)
		// 	.then((e) => {
		// 		setSameTvShow(e.data.results);
		// 		console.log("sameTvShow", e.data.results);
		// 	})
		// 	.catch((error) => console.log(error));

		// axios
		// 	.get(
		// 		`https://api.themoviedb.org/3/movie/${id}/recommendations?api_key=0bcafd5b459497ec53d81e9fc940f86d&language=en-US&page=1`
		// 	)
		// 	.then((res) => {
		// 		setSameMovie(res.data.results);
		// 		console.log("sameMovie", res.data.results);
		// 	})
		// 	.catch((error) => console.log(error));

		// console.log();
		// console.log("bs smaeTvSHow", sameTvShow);
		// console.log("bs : sameMovie", sameMovie);
		if (
			(sameMovie !== undefined && sameMovie.length > 5) ||
			(sameTvShow !== undefined && sameTvShow.length > 5)
		) {
			setShowPresent(true);
		}
		return () => {
			console.log("Damn it");
		};
	}, [id]);

	const CloseTrailer = () => {
		setNum(() => {
			return 0;
		});
		setClicked(!clicked);
		setLink("");
		document.getElementById("player").style.display = "none";
		document.getElementById("closed").style.display = "none";
	};
	const plays = () => {
		fetch(
			`https://api.themoviedb.org/3/movie/${id}/videos?api_key=0bcafd5b459497ec53d81e9fc940f86d&language=en-US`
		)
			.then((res) => res.json())
			.then((res) => {
				const Trailer = res.results.filter((e) => {
					return e.type === "Trailer";
				});
				const Teaser = res.results.filter((e) => {
					return e.type === "Teaser";
				});
				console.log("Teaser or Trailer", res);
				console.log("Trailer", Trailer);
				console.log("Teaser", Teaser);
				if (res.results.length >= 1) {
					setLink((prev) => {
						return Trailer[0].key !== undefined
							? Trailer[0].key
							: Teaser[0].key;
					});
				}
			})
			.catch((error) => console.log(error));
		document.getElementById("player").style.display = "block";
		document.getElementById("closed").style.display = "block";
	};
	const dragged = (e) => {
		if (!isDragged) return;
		e.target.scrollLeft -= e.movementX;
		document.getElementById("container").classList.add("dragging");
		console.log(e.target.scrollLeft, e.movementX);
	};
	// document.addEventListener("mouseup", setIsDragged(false));
	// console.log(sameTvShow);
	const prev = () => {
		document.getElementById("container").scrollLeft += -350;
	};
	const next = () => {
		document.getElementById("container").scrollLeft += 350;
	};
	const prevs = () => {
		document.getElementById("containers").scrollLeft += -350;
		console.log(document.getElementById("containers").scrollLeft);
	};
	const nexts = () => {
		document.getElementById("containers").scrollLeft += 350;
		console.log(document.getElementById("containers").scrollLeft);
	};
	const draggedStop = () => {
		setIsDragged(false);
		document.getElementById("container").classList.remove("dragging");
	};
	return (
		<>
			<Youtube isClicked={clicked}>
				{linkset && (
					<button
						onClick={CloseTrailer}
						className="closed"
						id="closed">
						Close
					</button>
				)}
				{linkset && (
					<iframe
						className="top"
						id="player"
						title={data[0].name || data[0].title}
						type="text/html"
						src={`https://www.youtube.com/embed/${
							clicked && linkset
						}?autoplay=${num}`}
						allowFullScreen
						frameBorder="0"></iframe>
				)}
			</Youtube>
			<Main isClicked={clicked} onMouseUp={draggedStop}>
				<Container>
					<DetailImg>
						<img
							src={`https://image.tmdb.org/t/p/original/${data[0].poster_path}`}
							alt="ku"
						/>
					</DetailImg>
					<Controls>
						<h3 style={{ color: "yellow" }}>Subscriber</h3>

						<h2
							style={{
								letterSpacing: "2px",
							}}
							className="title">
							{data[0].name || data[0].title}
						</h2>
						<br />
						<Desc>
							<h4>{data[0].release_date}</h4>
						</Desc>
						<br />
						<p>{data[0].overview.slice(0, 220)} ...</p>
						<br />
						<br />
						<ControlButtons>
							<MovieButton mv={clicked} onClick={playTrailer}>
								<h2>{clicked}</h2>{" "}
								<img
									src="./images/play-icon-white.png"
									alt="play"
								/>
								<span>
									{linkset !== undefined ? (
										<span onClick={plays}>
											Watch Trailer{" "}
										</span>
									) : (
										<span>No Trailer Present</span>
									)}
								</span>
								{/* {linkset && (
									<button
										onClick={CloseTrailer}
										className="closed"
										id="closed">
										Close
									</button>
								)}
								{linkset && (
									<iframe
										className="top"
										id="player"
										title={data[0].name || data[0].title}
										type="text/html"
										src={`https://www.youtube.com/embed/${
											clicked && linkset
										}?autoplay=${num}`}
										allowFullScreen
										frameBorder="0"></iframe>
								)} */}
							</MovieButton>
							<WatchButton>
								<div>
									<button>+</button>
									<h6>WATCHLIST</h6>
								</div>
								<div>
									<button>+</button>
									<h6>SHARE</h6>
								</div>
							</WatchButton>
						</ControlButtons>
					</Controls>
					{/* <Gradient></Gradient> */}
				</Container>
				<br />
				<br />
				<h2 style={{ marginleft: "23px", padding: "20px 74px" }}>
					Cast
				</h2>

				<Containers>
					{((state !== undefined && state.length > 2) ||
						(tvCast !== undefined && tvCast.length > 2)) && (
						<>
							<button onClick={prev} id="prev">
								<img src="./images/left.png" alt="prev" />
							</button>
							<button onClick={next} id="next">
								<img src="./images/next(1).png" alt="prev" />
							</button>
						</>
					)}
					<ContainerOfBox
						id="container"
						onMouseMove={dragged}
						onMouseDown={() => setIsDragged(true)}>
						{state !== undefined && state.length > 10
							? state.map((e) => {
									return (
										<Link
											key={e.id}
											to={"/cast"}
											className="text"
											state={{ data: e.id }}>
											<Box key={e.id}>
												<div className="img">
													<img
														draggable="false"
														src={`https://image.tmdb.org/t/p/original/${e.profile_path}`}
														alt={e.name}
													/>
												</div>
												<div className="h6">
													<h6
														draggable="false"
														style={{
															color: "white",
														}}>
														{e.name}
													</h6>
												</div>
											</Box>
										</Link>
									);
							  })
							: tvCast.map((e) => {
									return (
										<Link
											key={e.id}
											to={"/cast"}
											className="text"
											state={{ data: e.id }}>
											<Box key={e.id}>
												<img
													src={`https://image.tmdb.org/t/p/original/${e.profile_path}`}
													alt={e.name}
												/>
												<div className="h6">
													<h6
														style={{
															color: "white",
														}}>
														{e.name}
													</h6>
												</div>
											</Box>
										</Link>
									);
							  })}
						{/* </Link> */}
					</ContainerOfBox>
				</Containers>
				{(sameMovie !== undefined && sameMovie.length > 10) ||
				(sameTvShow !== undefined && sameTvShow.length > 10) ? (
					<h2 style={{ marginleft: "23px", padding: "20px 74px" }}>
						Recommended
					</h2>
				) : (
					<h2 style={{ marginleft: "23px", padding: "20px 74px" }}>
						Recommended shows not available
					</h2>
				)}
				<Containers>
					{((sameMovie !== undefined && sameMovie.length > 10) ||
						(sameTvShow !== undefined &&
							sameTvShow.length > 10)) && (
						<>
							<button onClick={prevs} id="prev">
								<img src="./images/left.png" alt="prev" />
							</button>
							<button onClick={nexts} id="next">
								<img src="./images/next(1).png" alt="prev" />
							</button>
						</>
					)}
					<ContainerOfBox
						id="containers"
						onMouseMove={dragged}
						onMouseDown={() => setIsDragged(true)}>
						{sameMovie !== undefined && sameMovie.length > 10
							? sameMovie.map((e) => {
									console.log("sameMovie");
									return (
										<Link
											key={e.id}
											to={"/detail"}
											className="text"
											state={{
												data: sameMovie.filter(
													(info) => {
														return info.id === e.id;
													}
												),
											}}>
											<Box key={e.id}>
												<img
													src={`https://image.tmdb.org/t/p/original/${e.poster_path}`}
													alt={e.original_title}
												/>
												<div className="h6">
													<h6
														style={{
															color: "white",
														}}>
														{e.original_title}
													</h6>
												</div>
											</Box>
										</Link>
									);
							  })
							: sameTvShow !== undefined &&
							  sameTvShow.map((e) => {
									console.log("sameTvShows");
									return (
										<Link
											key={e.id}
											to={"/detail"}
											className="text"
											state={{
												data: sameTvShow.filter(
													(info) => {
														return info.id === e.id;
													}
												),
											}}>
											<Box>
												<img
													src={`https://image.tmdb.org/t/p/original${e.poster_path}`}
													alt={e.original_name}
												/>
												<div className="h6">
													<h6
														style={{
															color: "white",
														}}>
														{e.original_name}
													</h6>
												</div>
											</Box>
										</Link>
									);
							  })}
					</ContainerOfBox>
					{/* </Link> */}
				</Containers>
			</Main>
		</>
	);
};

export default Detail;
// const Main = styled.div`
// 	opacity: 1;
// `;
const Youtube = styled.div`
	position: absolute;
	span {
		// margin-left: 5px;
		font-size: 22px;
		font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
			Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
		color: #fff;
		letter-spacing: 1.5px;
	}
	& .closed {
		display: ${(props) => (props.mv === true ? "block" : "none")};
		position: fixed;
		top: 9.3%;
		// left: 50%;
		border: 0;

		cursor: pointer;
		background-color: #050e19;
		color: white;
		border-radius: 7px;
		padding: 10px 17px;

		z-index: 10000;
		// text-align: center;
		left: 50%;
		transform: translateX(-50%);
		// right: 50%;
	}
	& iframe {
		display: ${(props) => (props.mv === true ? "block" : "none")};
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 70vw;
		height: 70vh;

		z-index: 100000;
	}
	@media (max-width: 250px) {
		.closed {
			top: 5%;
		}
	}
`;
const Main = styled.div`
	padding: 0;
	margin: 0;
	box-sizing: border-box;
	background-position: center;
	background-size: cover;
	overflow: hidden;
	filter: blur(${(props) => (props.isClicked === true ? 5 : "")}px);
`;
const ContainerOfBox = styled.div`
	width: 96vw;
	height: 100%;
	display: flex;
	align-items: center;
	// background: #fff;
	// position: relative;
	overflow: hidden;
	& .dragging {
		scroll-behaviour: auto;
		cursor: grab;
	}
	img {
		width: 100%;
		height: 100%;
	}
	@media (max-width: 648px) {
		width: 80vw;
	}

	@media (max-width: 320px) {
		width: 87vw;
	}
`;
const Containers = styled.div`
	height: 220px;
	display: flex;
	align-items: center;
	padding-left: 40px;
	position: relative;
	overflow: hidden;
	scroll-behaviour: smooth;
	cursor: grab;
	outline: none;
	& #prev {
		position: absolute;
		top: 40%;
		left: -2px;
		width: 30px;
		border: 0;
		background-color: transparent;
		color: white;

		z-index: 1000;
		outline: none;
		cursor: pointer;

		// padding: 15px;
	}

	& #next {
		position: absolute;
		top: 40%;
		// position: sticky;
		right: -3px;
		border: 0;
		// font-size: 26px;
		outline: none;

		z-index: 1000;
		cursor: pointer;

		background-color: transparent;
		// border: 0;
		// padding: 15px;
	}
	@media (max-width: 648px) {
		& #prev {
			left: -8px;
		}
		& #next {
			// right: 0;
		}
	}

	@media (max-width: 320px) {
		padding-left: 20px;
		width: 100vw;
		& #next {
			width: 5px;

			right: 16px;
			z-index: 10000;
		}
		& #prev {
			width: 5px;

			left: -5px;
		}
	}
`;
const Box = styled.div`
	height: 220px;
	width: 150px;
	// box-sizing: border-box;
	margin-right: 40px;
	// background: #fff;
	border: none;
	display: flex;
	// outline: none;

	scroll-behaviour: smooth;
	flex-direction: column;
	align-items: center;
	transition: transform 0.3s;
	-webkit-user-select: none;
	user-select: none;
	-webkit-touch-callout: none;
	-khtml-user-select: none;
	touch-action: pan-y;
	-webkit-tap-highlight-color: transparent;
	& .img {
		height: 80%;
		width: 100%;
	}
	img {
		height: 100%;
		width: 100%;
		border-radius: 50%;
		object-fit: cover;
		margin-bottom: 10px;
		user-select: none;
	}
	&.text {
		color: #fff;
	}
	& .h6 {
		height: 20%;
		z-index: 10000;
	}
	& h6 {
		user-select: none;
	}
	&:hover {
		transform: scale(1.1);
	}
	@media (max-width: 1024px) {
		& {
			width: 100px;
			height: 100px;
		}
	}
	@media (max-width: 768px) {
		& {
			width: 100px;
			height: 100px;
		}
	}
	@media (max-width: 648px) {
		& {
			width: 85px;
			height: 85px;
		}
	}
	@media (max-width: 500px) {
		& {
			width: 85px;
			height: 85px;
		}
	}
`;
const Container = styled.div`
	position: relative;
	min-height: calc(100vh-60px);
	// padding: 0 23px;
	padding-left: 23px;
	// margin-right: 20px;
	width: 97vw;
	// border: 2px solid rgba(0, 0, 255, 0.644);
	border-radius: 10px;
	margin-top: 20px;
	display: flex;
	align-items: center;
	background-color: #030b17;
	@media (max-width: 768px) {
		& {
			flex-direction: column;
			align-self: auto;
			border: none;
			width: 100vw;
			margin-left: 0px;
			margin-top: 0;
			padding-left: 0px;
			/* padding:6px; */
			font-size: 10px;
		}
	}
`;
const ControlButtons = styled.div`
	height: max-content;
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;
	@media (max-width: 912px) {
		span {
			font-size: 12px;
		}
		font-size: smaller;
	}
`;
const MovieButton = styled.div`
	display: flex;
	align-items: center;
	cursor: pointer;
	z-index: 1000;
	// span {
	// 	margin-left: 5px;
	// 	font-size: 22px;
	// 	font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
	// 		Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
	// 	color: #fff;
	// 	letter-spacing: 1.5px;
	// }
	// & .closed {
	// 	// display: block;
	// 	display: ${(props) => (props.mv === true ? "block" : "none")};
	// 	position: fixed;
	// 	top: 60px;
	// 	border: 0;
	// 	cursor: pointer;
	// 	background-color: rgb(216, 84, 84);
	// 	border-radius: 7px;
	// 	padding: 10px 17px;

	// 	z-index: 10000;
	// 	left: 50%;
	// }
	// & iframe {
	// 	display: ${(props) => (props.mv === true ? "block" : "none")};
	// 	position: fixed;
	// 	top: 50%;
	// 	left: 50%;
	// 	transform: translate(-50%, -50%);
	// 	width: 80vw;
	// 	height: 70vh;
	// 	z-index: 100000;
	// }
`;

const WatchButton = styled.div`
	display: flex;
	justify-content: center;
	cursor: pointer;
	button {
		border: none;
		cursor: pointer;
		font-size: 40px;
		background: none;
		color: #fff;
	}
	div {
		display: flex;
		flex-direction: column;
		margin-right: 20px;
	}
`;
const Gradient = styled.div`
	// min-width: 10%;
	background: linear-gradient(to right, #030b17, rgba(0, 0, 0, 0));
	// overflow: hidden;
	// opacity: 0.3;
`;
const DetailImg = styled.div`
	min-width: 50%;
	height: 400px;

	& img {
		width: 100%;
		height: 100%;
		object-fit: fill;
		// opacity: 0.5;
		border-radius-left: 0px;
		border-top-right-radius: 10px;
		border-bottom-right-radius: 10px;
		box-shadow: -15px 10px 10px 0px #091019;
		// border-radius: 10px;
		aspect-ratio: calc(9 / 16 * (100));
	}
	@media (max-width: 768px) {
		& {
			display: block;
			// width: 100%;
			// height: 100%;

			img {
				width: 100%;
				height: 100%;
				background-size: cover;
				object-fit: cover;
			}
		}
	}
`;
const Controls = styled.div`
	display: flex;
	flex-direction: column;
	padding-left: 50px;
	overflow: visible;
	border-radius: 10px;
	min-width: 50%;
	opacity: 0.7;
	// z-flex: 100;
	height: 100%;
	// background-color: #040714;

	// overflow: visisble;

	&:after {
		border-right: 2px ridge black;
		border-left: transparent;
		opacity: 0.3;
	}
	& h2 {
		padding-bottom: 20px;
		font-family: "Roboto";
	}
	@media (max-width: 768px) {
		& {
			flex-direction: column;
			padding-left: 10px;
			padding-right: 20px;
			padding-top: 10px;
			padding-bottom: 10px;
		}
	}
`;

const Desc = styled.div`
	display: flex;
	h4 {
		&:after {
			content: ".";
		}
	}
`;

const Wrapbg = styled.div`
	padding: 0px calc(3.5vw);
	img {
		height: 100%;
		width: 100%;
		position: fixed;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		z-index: -1;
		opacity: 0.4;
	}
`;

const Wrap = styled.div``;

const PLayButton = styled.button`
	display: flex;
	cursor: pointer;
	align-items: center;
	padding: 3px 10px;
	/* margin-right: 10px; */
	letter-spacing: 1.8px;
	opacity: 0.5;
	/* color: #fff; */
`;

const TrailerButton = styled.button`
	display: flex;
	cursor: pointer;
	align-items: center;
	padding: 3px 10px;
	letter-spacing: 1.8px;
`;
const AddButton = styled.button`
	height: 50px;
	cursor: pointer;
	font-size: 30px;
	border: 2px solid rgb(249, 249, 249, 0.8);
	/* border-color: rgb(249,249,249,0.8); */
	/* background: rgb(198,198,198,0.8); */
	background: rgb(100, 100, 100, 0.8);
	width: 50px;
	/* border: none; */
	border-radius: 50%;
`;

const GroupButton = styled.button`
	cursor: pointer;
	height: 50px;
	width: 50px;
	border-radius: 50%;
	border: none;
	background-color: #100;
`;
